import store from '../../../store/store';
import { asyncHandler } from '../async-handler';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { MCP_CREDENTIALS_API } from '../../constants/central-api';
import { submitLogToBugsnag } from '../log';

export default async function connect_mcp_api_call(
  mcpId: number,
  credentials: any,
  oauthCode?: string
) {
  try {
    const shopSlug = store.getState().user?.company?.shop_slug;
    const accessToken = store.getState().auth.authorization.accessToken;
    const isWhiteLabel = store.getState().UI?.isWhiteLabel;
    let sellerToken: string;
    if (isWhiteLabel) {
      sellerToken = accessToken?.currentWhiteLabelSellerToken;
    } else {
      sellerToken = accessToken?.sellerToken;
    }

    //* Format the credentials to add manual accounts to the credentials list
    const formatted_credentials: any = {};

    for (const key in credentials) {
      if (credentials.hasOwnProperty(key)) {
        const value = credentials[key];

        if (
          value === 'manual_account' &&
          credentials.hasOwnProperty(`${key}_manual`)
        ) {
          formatted_credentials[key] = credentials[`${key}_manual`];
        } else if (!key.endsWith('_manual')) {
          if (
            !(
              credentials[key] === 'manual_account' &&
              credentials.hasOwnProperty(`${key}_manual`)
            )
          ) {
            formatted_credentials[key] = value;
          }
        }
      }
    }

    const requestInfo: RequestInfo = {
      url: MCP_CREDENTIALS_API(shopSlug),
      method: 'POST',
      body: JSON.stringify({
        tara_mcp_id: mcpId,
        credentials: formatted_credentials,
        oauth_code: oauthCode,
      }),
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        Authorization: accessToken.type + ' ' + sellerToken,
      },
    };

    const actionType = 'ADD_MCP_CONNECTION';
    const customMsg = 'Integration Connection Successful.';

    const res: any = await asyncHandler(
      requestInfo,
      actionType,
      customMsg,
      true,
      false,
      false,
      false,
      ['You have reached the maximum number of credentials for the free tier']
    );

    const response = res.data;

    if (res.actionType === actionType) {
      return response;
    } else {
      return {};
    }
  } catch (exception) {
    console.log('Error during authentication request');
    submitLogToBugsnag('error', `${exception}`);
    return false;
  }
}
